import { SNETButton } from "shared/dist/components/domainless/data-entry";
import { SNETDialog } from "shared/dist/components/domainless/overlay/dialog";
import classes from "./SuccessDialog.module.css";

export const SuccessDialog = ({ onDialogClose, ...rest }) => {
    return (
        <SNETDialog
            showCloseButton={false}
            title="Success!"
            titleClass={classes.title}
            sx={{ "& .MuiPaper-root": { maxWidth: "420px" } }}
            {...rest}
        >
            <div className={classes.content}>
                <div className={classes.description}>
                    <svg
                        width="48"
                        height="37"
                        viewBox="0 0 48 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M44.1549 0L15.255 29.1889L3.87515 17.6861L0 21.5764L15.255 37L48 3.89038L44.1549 0Z"
                            fill="#00C48C"
                        />
                    </svg>
                    <div>
                        Don't forget to top up your account on{" "}
                        <a href="/deployments">My Deployments</a> page after service publishing to
                        make the service available!
                    </div>
                </div>
                <SNETButton onClick={onDialogClose} style={{ width: "100%" }}>
                    Ok
                </SNETButton>
            </div>
        </SNETDialog>
    );
};
